import React from "react";
import 'normalize.css';
// import Header from "./Header";

export default function CollectKart() {
  return (
    <main id="content" className="content">
        {/* <Header/> */}
      {/* <section
        className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
        style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
        data-parallax="true"
        data-parallax-options={{ parallaxBG: true }}
      >
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-6">
              <h1
                className="text-white pr-md-5 mt-0 mb-40"
                data-split-text="true"
                data-split-options={{ type: "lines" }}
              >
                Collect Kart Document Collection - An Innovative Phygital Platform By DocBoyz
              </h1>
              <p
                className="text-white font-size-16 lh-185 pr-md-7 mb-60"
                data-split-text="true"
                data-split-options={{ type: "lines" }}
              >
                A Phygital platform designed for collection of documents and customer data. A multi-smart architecture offering flexibility for endless expansion without any hassle. Helping BFSI companies and expanding Phygital operations in our Fintech correspondent agency network.
              </p>
            </div>

            <div className="lqd-column col-md-6">
              <form className="contact-form">
                <div className="form-group">
                  <label htmlFor="name" className="text-white">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="text-white">
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter your email"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="text-white">
                    Your Message
                  </label>
                  <textarea
                    id="message"
                    className="form-control"
                    rows="5"
                    placeholder="Write your message here"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section> */}
<section
  className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
  style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
  data-parallax="true"
  data-parallax-options={{ parallaxBG: true }}
>

  <div className="container">
  <div className="text-center">
    <h4 className="content text-white">Effortless & Secure Document Collection for Financial Institutions
      <br></br>
      {/* DocBoyz Platform - complete eco-system for Collection */}
    </h4>
  </div>
    
    {/* First Div - Left Content, Right Image */}
    <div className="row align-items-center mb-50">
      <div className="col-md-6">
        <div className="content text-white">
          <h2 className="content text-white">Document Collection-DocBoyz</h2>
          <p>
          At DocBoyz, we revolutionize the way financial institutions handle document collection. Our streamlined processes eliminate the typical hassles, ensuring a smooth and efficient experience for both lenders and borrowers. Whether you’re dealing with personal loans, home loans, or vehicle loans, our document collection services ensure precision and security every step of the way.
          </p>
        </div>
      </div>
      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/CollectKart/man-shaking-hands.jpg" alt="Image 1" className="img-fluid" />
        </div>
      </div>
    </div>

    {/* Second Div - Right Content, Left Image */}
    <div className="row align-items-center mb-50 flex-row-reverse">
      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/CollectKart/man_collection.jpg" alt="Image 2" className="img-fluid" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="content text-white">
          <h2 className="content text-white">Document Collection Services</h2>
          <p>
            DocBoyz provides the best experience with speed in document collection for Banks & NBFCs. Our pan-India Fintech correspondent network is well trained to handle any financial document collection with full integrity and safety. They are courteous and equipped with our powerful DocBoyz collection app. All the documents are scanned and transmitted digitally in real-time using our platform.
          </p>
        </div>
      </div>
    </div>

    {/* Third Div - Left Content, Right Image */}
    <div className="row align-items-center mb-50">
      <div className="col-md-6">
        <div className="content text-white">
          <h2 className="content text-white">Services</h2>
          <ul>
            <li>✓ Home Loans Documents</li>
            <li>✓ Personal Loans Documents</li>
            <li>✓ Auto Loan Documents</li>
            <li>✓ Insurance Documents</li>
            <li>✓ Payment Mandate and Contact Document</li>
          </ul>
        </div>
      </div>

      <div className="col-md-6">
        <div className="image">
          <img src="assets/img/CollectKart/creative.jpg" alt="Image 3" className="img-fluid" />
        </div>
      </div>
    </div>
    
  </div>
</section>


      {/* Services Section */}
      <section className="vc_row bg-no-repeat  pt-10 pb-10 d-flex justify-content-center align-items-center" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="text-center">
    <h1>DocBoyz Eco System
      <br></br>
      DocBoyz Platform - complete eco-system for Collection
    </h1>
  </div>
</section>

      {/* my-app\public\assets/img/CollectKart/dashboard.png */}
     
<section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row">
      <div className="lqd-column col-md-4">
        <img src="assets/img/CollectKart/dashboard.png" alt="Document Collection" style={{ width: '100%', marginBottom: '20px' }} />
        <h3>Customer Portal</h3>
        <p>
          Customers can track their cases real time using the customer portal
        </p>
      </div>

      <div className="lqd-column col-md-4">
        <img src="assets/img/CollectKart/app_Screen.png" alt="Services Offered" style={{ width: '100%', marginBottom: '20px' }} />
        <h3>DocBoyz Mobile App</h3>
        <p>
        The mobile app is used by our Fintech Correspondents to seamlessly accept and digitally execute the case
        </p>
      </div>

      <div className="lqd-column col-md-4">
        <img src="assets/img/CollectKart/console.png" alt="DocBoyz Eco System" style={{ width: '100%', marginBottom: '20px' }} />
        <h3>DocBoyz Eco System</h3>
        <p>
        DocBoyz platform provides a complete ecosystem for document collection and transmission, ensuring compliance and security for a range of business services.
        </p>
      </div>
    </div>
  </div>
</section>
{/* my-app\public\assets/img/CollectKart/integration.png */}
<section className="vc_row bg-no-repeat pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row d-flex justify-content-center">
      <div className="lqd-column col-md-4 text-center">
        <img src="assets/img/CollectKart/api.jpg" alt="Document Collection" style={{ width: '100%', marginBottom: '20px' }} />
        <h3>Customer APIs</h3>
        <p>
          DocBoyz exposes APIs to customers to easily integrate with their internal systems.
          DocBoyz Website for Bank and NBFCs for document collection.
        </p>
      </div>

      <div className="lqd-column col-md-4 text-center">
        <img src="assets/img/CollectKart/website.png" alt="Services Offered" style={{ width: '100%', marginBottom: '20px' }} />
        <h3>Corporate Website</h3>
        <p>
          The mobile app is used by our Fintech Correspondents to seamlessly accept and digitally execute the case.
          Customers can track their cases in real-time using the customer portal.
        </p>
      </div>
    </div>
  </div>
</section>


<section className="vc_row bg-no-repeat  pt-10 pb-10 d-flex justify-content-center align-items-center" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="text-center">
    <h1>DocBoyz Platform Features

    </h1>
    <h2>Our cloud based platform and digitally enabled pan-India Fintech Correspondent Network.</h2>
  </div>
</section>

{/*  */}
<section className="vc_row bg-no-repeat pt-100 pb-100 d-flex justify-content-center align-items-center" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row text-center">

      {/* First Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/integration.png" alt="Self Integrate API" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Self Integrate API</h5>
      </div>

      {/* Second Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/profile (1).png" alt="Digital KYC" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Digital KYC</h5>
      </div>

      {/* Third Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/detection.png" alt="Fraud Detection" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Fraud Detection</h5>
      </div>

      {/* Fourth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/cyber-security.png" alt="Data Encryption" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Data Encryption</h5>
      </div>

      {/* Fifth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/networking.png" alt="Real Time Verification" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Real Time Verification</h5>
      </div>

      {/* Sixth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/networking.png" alt="Geo Tagging" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Geo Tagging</h5>
      </div>

      {/* Seventh Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/security.png" alt="Secured" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Secured</h5>
      </div>

      {/* Eighth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/networking.png" alt="Pickup Scheduling" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Pickup Scheduling</h5>
      </div>

      {/* Ninth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/networking.png" alt="Transparent Process" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Transparent Process</h5>
      </div>

      {/* Tenth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/rocket.png" alt="Fast" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Fast</h5>
      </div>

      {/* Eleventh Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/location.png" alt="Real Time Tracking" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Real Time Tracking</h5>
      </div>

      {/* Twelfth Column */}
      <div className="col-md-3 col-sm-6 mb-4">
        <img src="assets/img/CollectKart/networking.png" alt="Pan-India Network" style={{ width: '50px', marginBottom: '10px' }} />
        <h5>Pan-India Network</h5>
      </div>

    </div>
  </div>
</section>



{/*  */}

<section className="vc_row bg-no-repeat pt-10 pb-10" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
  <div className="container">
    <div className="row d-flex justify-content-center">
      <div className="lqd-column col-md-4 text-center">
        <h3>Customer APIs</h3>
        <p>
        Easy to use and intuitive user interface
        Which has been well adopted by FCs
        </p>
        <img src="assets/img/CollectKart/google_play.png" alt="Document Collection" style={{ width: '50%', marginBottom: '20px' }} />

      </div>

      <div className="lqd-column col-md-4 text-center">
        <img src="assets/img/CollectKart/app_screen.png" alt="Services Offered" style={{ width: '100%', marginBottom: '20px' }} />
        {/* <h3>Corporate Website</h3>
        <p>
          The mobile app is used by our Fintech Correspondents to seamlessly accept and digitally execute the case.
          Customers can track their cases in real-time using the customer portal.
        </p> */}
      </div>
    </div>
  </div>
</section>


{/*  */}

<section class="vc_row">
      <div class="container">
      <div class="row">

        <div class="lqd-column col-md-12">

          <div class="carousel-container carousel-nav-left carousel-nav-md carousel-dots-style1">

            <div  data-lqd-flickity='{"cellAlign":"left","prevNextButtons":false,"buttonsAppendTo":"self","pageDots":false,"groupCells":false,"wrapAround":true,"autoPlay":3000,"pauseAutoPlayOnHover":false}'>

            <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-0.png" class="mt-10 w-200" alt="Client"/>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/DcbBank1.png" class="mt-10 w-200" alt="Client"/>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-1.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/client-6.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/Fibe.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/muthoot.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
              <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/Suryoday.png" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
             <div class="lqd-column carousel-item  col-md-2 col-sm-3 col-xs-4">
                <figure class="text-center opacity-02 reset-opacity-onhover">
                  <img src="assets/img/patner/logo.svg" class="mt-10 w-200" alt="Client"></img>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </section>


{/*  */}

{/*  */}

<section
  className="vc_row fullheight d-flex flex-wrap align-items-center bg-cover pt-150 pb-150"
  style={{ backgroundImage: "url(assets/demo/bg/bg-14.jpg)" }}
  data-parallax="true"
  data-parallax-options={{ parallaxBG: true }}
>
  <div className="container">
    <div className="row">
      {/* Left Content */}
      <div className="lqd-column col-md-6">
        <h1
          className="text-white pr-md-5 mt-0 mb-40"
          data-split-text="true"
          data-split-options={{ type: "lines" }}
        >
          Contact Us Now
        </h1>
        <p
          className="text-white font-size-16 lh-185 pr-md-7 mb-30"
          data-split-text="true"
          data-split-options={{ type: "lines" }}
        >
          Feel free to get in touch with us, our team will be happy to assist. Enter your details below to get started.
        </p>
        <p
          className="text-white font-size-16 lh-185 pr-md-7 mb-60"
          data-split-text="true"
          data-split-options={{ type: "lines" }}
        >
          Fill out the form below to get in touch with us. Don't worry, we never share your information or use it to spam you.
        </p>
      </div>

      {/* Right Form */}
      <div className="lqd-column col-md-6">
        <form className="contact-form">
          <div className="form-group">
            <label htmlFor="firstName" className="text-white">
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              className="form-control"
              placeholder="Enter your first name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName" className="text-white">
              Last Name
            </label>
            <input
              type="text"
              id="lastName"
              className="form-control"
              placeholder="Enter your last name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="mobileNumber" className="text-white">
              Mobile Number
            </label>
            <input
              type="tel"
              id="mobileNumber"
              className="form-control"
              placeholder="Enter your mobile number"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email" className="text-white">
              Email
            </label>
            <input
              type="email"
              id="email"
              className="form-control"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message" className="text-white">
              Message Here
            </label>
            <textarea
              id="message"
              className="form-control"
              rows="5"
              placeholder="Write your message here"
              required
            ></textarea>
          </div>

          <button
            type="submit"
            className="btn btn-solid text-uppercase btn-md circle btn-bordered border-thin btn-gradient px-2"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  </div>
</section>


{/*  */}
      {/* Contact Info Section */}
      <section className="vc_row bg-no-repeat pt-100 pb-100" style={{ backgroundImage: "url(assets/demo/bg/bg-76.svg)", backgroundPosition: "-90% 80%" }}>
        <div className="container">
          <div className="row">
            <div className="lqd-column col-md-4">
              <h3>Contact Information</h3>
              {/* <p>
                <strong style={{ color: '#000' }}>Corporate Office -</strong> 
                <br></br>
                <strong style={{ color: '#333' }}>Pune:</strong> 
                <br></br>
                Novacred Pvt Ltd (DocBoyz), 105, Hermes Waves Central Avenue Road Kalyani Nagar, Pune, Maharashtra - 411006, India
                <br></br>
                
                <strong style={{ color: '#333' }}>Mumbai:</strong> 
                <br></br>
                C-106 Kanishka GE Links CHS, Ram Mandir Road Goregaon West, Mumbai - 400104, India 
              </p>
              <p>
                <strong style={{ color: '#333' }}>Email:</strong>  info@docboyz.in
              </p>
              <p>
                <strong style={{ color: '#333' }}>Phone:</strong> +91 8470067555
              </p> */}
              
            </div>

            {/* Optional: Embed Google Map */}
            <div className="lqd-column col-md-8">
              {/* <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345093424!2d144.9537353153154!3d-37.81627917975143!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf577350ba5f0a2df!2sVictoria!5e0!3m2!1sen!2sau!4v1510917516893"
                width="100%"
                height="400"
                allowFullScreen=""
                loading="lazy"
                title="Company Location"
              ></iframe> */}
            </div>
          </div>
        </div>
      </section>
     
    </main>
  );
}
